import { OrgModuleService } from "./types";
import { useOrgModuleService } from "./useOrgModuleService";

export type { OrgModuleService };

export { useOrgModuleService };
